export default __webpack_public_path__ + "static/media/080_finish_soso.first.ef06f4fe.png";